
const namespaced = true

// state
export const state = {
	useFontOutline: false,
	defaultTemplate: null,
}

// getters
export const getters = {
	useFontOutline: state => state.useFontOutline,
	defaultTemplate: state => state.defaultTemplate
}

// mutations
export const mutations = {

	updateSetting(state, { setting, value }) {
		state[setting] = value
	},

}

// actions
export const actions = {

	UPDATE_SETTING ({ commit }, { setting, value }) {
		commit('updateSetting', {setting: setting, value: value})

		// Update the settings object in local storage
		localStorage.setItem('settings', JSON.stringify(state))
	},

	/**
	 * Checks local storage for a item named settings
	 * If it exists, then set its settings
	 */
	GET_SETTINGS_FROM_LOCAL_STORAGE({ state, commit }) {
		let settings = localStorage.getItem('settings')
		if(settings) {
			settings = JSON.parse(settings)
			Object.keys(settings).forEach(key => {
				// Check that the setting is still in the original state so that it is not a removed setting
				if(state.hasOwnProperty(key)) {
					commit('updateSetting', {setting: key, value: settings[key]})
				}
			})
		}
	}
}

export default {
	namespaced,
	state,
	getters,
	actions,
	mutations
}